// Libellés lisibles pour les actions du journal d'audit (FR/EN)
const ACTION_LABELS = {
    fr: {
        'team.invited': "Membre invité à l'équipe",
        'team.removed': "Membre retiré de l'équipe",
        'team.updated': "Rôle d'un membre modifié",
        'workspace.created': 'Espace de travail créé',
        'workspace.updated': 'Espace de travail modifié',
        'workspace.deleted': 'Espace de travail supprimé',
        'plan.updated': 'Plan tarifaire mis à jour',
        'project.created': 'Projet créé',
        'project.updated': 'Projet modifié',
        'project.deleted': 'Projet supprimé',
        'project.restored': 'Projet restauré',
        'order.paid': 'Commande payée',
        'pack.subscribed': 'Pack activé',
        'pack.cancelled': 'Pack désactivé',
        'document.uploaded': 'Document ajouté',
        'document.deleted': 'Document supprimé',
        'budget.updated': 'Budget modifié',
        'invoice.created': 'Facture créée',
    },
    en: {
        'team.invited': 'Member invited to the team',
        'team.removed': 'Member removed from the team',
        'team.updated': 'Member role updated',
        'workspace.created': 'Workspace created',
        'workspace.updated': 'Workspace updated',
        'workspace.deleted': 'Workspace deleted',
        'plan.updated': 'Pricing plan updated',
        'project.created': 'Project created',
        'project.updated': 'Project updated',
        'project.deleted': 'Project deleted',
        'project.restored': 'Project restored',
        'order.paid': 'Order paid',
        'pack.subscribed': 'Pack activated',
        'pack.cancelled': 'Pack deactivated',
        'document.uploaded': 'Document uploaded',
        'document.deleted': 'Document deleted',
        'budget.updated': 'Budget updated',
        'invoice.created': 'Invoice created',
    },
};

const ENTITY_LABELS = {
    fr: {
        workspace_member: "membre d'équipe",
        workspace: 'espace de travail',
        account_plan: 'plan tarifaire',
        project: 'projet',
        order: 'commande',
        document: 'document',
        budget: 'budget',
        invoice: 'facture',
    },
    en: {
        workspace_member: 'team member',
        workspace: 'workspace',
        account_plan: 'pricing plan',
        project: 'project',
        order: 'order',
        document: 'document',
        budget: 'budget',
        invoice: 'invoice',
    },
};

export function auditActionLabel(action, lang = 'fr') {
    if (!action) return '—';
    const l = ACTION_LABELS[lang] || ACTION_LABELS.fr;
    if (l[action]) return l[action];
    // Fallback lisible : "project.created" → "Project · created"
    const parts = String(action).split('.');
    const pretty = parts.map(p => p.replace(/_/g, ' ')).join(' · ');
    return pretty.charAt(0).toUpperCase() + pretty.slice(1);
}

export function auditEntityLabel(entity, lang = 'fr') {
    if (!entity) return '—';
    const l = ENTITY_LABELS[lang] || ENTITY_LABELS.fr;
    return l[entity] || String(entity).replace(/_/g, ' ');
}
